import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { eventLabelGroupsConstants } from "../../constants/eventLabelGroups.contansts";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { breakoutStyle } from "./breakout.helper";
import { ScrollWrapper } from "../../helpers/module.helper";
import { Avatar, Collapse, IconButton, List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";

function BreakoutModule(props) {
  const [breakouts, setBreakouts] = useState([]);
  const [activeBreakouts, setActiveBreakouts] = useState([]);
  const { lang, eventId, template, clientKey } = props;
  const breakoutRef = useRef();
  const timerRef = useRef(null);
  breakoutRef.current = breakouts;
  useEffect(() => {
    init(eventId, eventLabelGroupsConstants.BREAKOUT_LABEL_GROUP, lang);
    fetchBreakouts();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const fetchBreakouts = () => {
    axios.get(`./api/meeting/breakouts/${eventId}?badgeNo=${clientKey}`).then(({ data }) => {
      setBreakouts(data);
      checkActiveBreakouts();
    });
  };
  const checkActiveBreakouts = () => {
    if (!timerRef.current) {
      timerRef.current = setInterval(checkActiveBreakouts, 5000);
    }
    let activeBreakouts = breakoutRef.current.filter((b) => {
      return b.timeRule > 0 ? +new Date(b.start) - b.timeRule * 60000 < +new Date() && +new Date(b.end) > +new Date() : true;
    });
    setActiveBreakouts(activeBreakouts);
  };
  const api = {
    ...props,
    activeBreakouts,
    breakoutTemplate: breakoutStyle(template),
  };

  return <BreakoutContainer {...api} />;
}

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(BreakoutModule);

const linkConverter = (link) => {
  let convertedLink = link;
  if (convertedLink.includes("digitalmeeting")) convertedLink = convertedLink.replace("digitalmeeting", "digitalarena");
  return convertedLink;
};

const BreakoutContainer = (props) => {
  const [open, setOpen] = useState({});
  const { breakoutTemplate, settings, activeBreakouts, lang, eventId, template } = props;
  const { title, subtitle, frame, list, listItem, readMore, description, rowDivider } = breakoutTemplate;
  const { avatar, text, button } = listItem;
  const { showTitle, showSubtitle, showAvatar, showButton, collapsibleDescription, divideTimeslot, filterByGroup, showAlternativeName = false } = settings;
  return (
    <div
      style={{
        ...frame,
        height: "100%",
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: -1,
        position: "relative",
      }}
    >
      {showTitle ? (
        <div
          style={{
            ...title,
            margin: "10px 15px",
            marginBottom: 0,
            fontFamily: title.fontFamily,
          }}
        >
          <EventLabel2 name="Breakouts" groupName="DigitalMeeting.Breakout" />
        </div>
      ) : null}
      {showSubtitle ? (
        <div
          style={{
            ...subtitle,
            margin: "10px 15px",
            marginBottom: 0,
            fontFamily: subtitle.fontFamily,
          }}
        >
          <EventLabel2 name="ChooseYourBreakout" groupName="DigitalMeeting.Breakout" />
        </div>
      ) : null}

      <ScrollWrapper {...props}>
        <List
          className="jir-scroll"
          style={{
            ...list,
            overflowY: "auto",
            paddingTop: 0,
            overflowX: "hidden",
            height: "100%",
          }}
        >
          {activeBreakouts.filter(ab => filterByGroup ? ab.filters.includes(filterByGroup.toLowerCase()) : true).map((b, i) => {
            const displayLang = b.eventDisplayLanguage.find((x) => x.languageCode === lang && x.alternative === showAlternativeName)
            return (
              <div key={i}>
                <ListItem
                  key={i}
                  className="breakout-item"
                  style={{ ...listItem, cursor: "pointer", paddingBottom: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    return !b.disabled && b.link && b.allowed && b.eventId != eventId
                      ? (window.location.href = (!window.location.toString().includes("localhost") ? "/interaction" : "") + "/" + linkConverter(b.link) + "&lang=" + lang)
                      : null;
                  }}
                >
                  {showAvatar ? (
                    <ListItemAvatar>
                      <Avatar
                        style={{
                          backgroundColor: b.eventId == eventId ? avatar.activeBackground : avatar.background,
                          color: b.eventId == eventId ? avatar.activeColor : avatar.color,
                        }}
                      >
                        <MeetingRoomIcon />
                      </Avatar>
                    </ListItemAvatar>
                  ) : null}
                  {b.eventId === 1171 || b.eventId === 2153 || b.eventId === 2154 || b.eventId == 2155 ?
                    <ListItemText primary={<div style={text}>{"BACK TO MAIN STAGE"}</div>} />
                    :
                    <ListItemText primary={<div style={text}>{displayLang?.name ? displayLang.name : b.name}</div>} />
                  }

                  {b.link && showButton ? (
                    <ListItemAvatar>
                      <IconButton
                        disabled={b.disabled}
                        onClick={(e) => {
                          e.stopPropagation();
                          window.location.href = (!window.location.toString().includes("localhost") ? "/interaction" : "") + "/" + linkConverter(b.link) + "&lang=" + lang;
                        }}
                        style={{
                          padding: 0,
                          backgroundColor: "transparent",
                          fontSize: button.fontSize + "!important",
                          color: button.color,
                        }}
                      >
                        <ExitToAppIcon />
                      </IconButton>
                    </ListItemAvatar>
                  ) : null}
                </ListItem>
                
                {displayLang?.description ?   
                  <>
                    {displayLang.description ? (
                      <Collapse in={!collapsibleDescription ? true : open[b.eventId]} timeout="auto" unmountOnExit>
                        <div style={{ ...description, padding: "0px 15px" }} dangerouslySetInnerHTML={{ __html: b.description }} />
                      </Collapse>
                    ) : null}
                    {displayLang.description && collapsibleDescription ? (
                      <div
                        onClick={() => setOpen({ ...open, [b.eventId]: !open[b.eventId] })}
                        style={{
                          ...readMore,
                          ...listItem,
                          marginLeft: "16px",
                          marginTop: readMore.marginTop || 0,
                          cursor: "pointer",
                        }}
                      >
                        {open[b.eventId] ? <EventLabel2 name="ShowLess" groupName="DigitalMeeting.Breakout" /> : <EventLabel2 name="ReadMore" groupName="DigitalMeeting.Breakout" />}
                      </div>
                    ) : null}
                  </>
                :                 
                  <>
                    {b.description ? (
                      <Collapse in={!collapsibleDescription ? true : open[b.eventId]} timeout="auto" unmountOnExit>
                        <div style={{ ...description, padding: "0px 15px" }} dangerouslySetInnerHTML={{ __html: b.description }} />
                      </Collapse>
                    ) : null}
                    {b.description && collapsibleDescription ? (
                      <div
                        onClick={() => setOpen({ ...open, [b.eventId]: !open[b.eventId] })}
                        style={{
                          ...readMore,
                          ...listItem,
                          marginLeft: "16px",
                          marginTop: readMore.marginTop || 0,
                          cursor: "pointer",
                        }}
                      >
                        {open[b.eventId] ? <EventLabel2 name="ShowLess" groupName="DigitalMeeting.Breakout" /> : <EventLabel2 name="ReadMore" groupName="DigitalMeeting.Breakout" />}
                      </div>
                    ) : null}
                  </>
                }

                {divideTimeslot ? (
                  i + 1 <= activeBreakouts.length - 1 && activeBreakouts[i + 1].start != activeBreakouts[i].start ? (
                    <hr style={{ ...rowDivider, marginBottom: "0.5rem", marginTop: "0.5rem" }} />
                  ) : null
                ) : null}
              </div>
            );
          })}
        </List>
      </ScrollWrapper>
    </div>
  );
};
